import React from "react";
import SelectFormField from "../SelectFormField/SelectFormField";
import DatePickerInput from "../DatePicker/DatePickerInput";
import { Controller } from "react-hook-form";
import useComponentVisible from "../OutsideClick/useComponentVisible";
import DatePicker from "../FormDatePicker/DatePicker";
import { useSelector } from "react-redux";
import { notesSliceSelector } from "../../../features/notes/notesSlice";

function NotesFilter({
  search,
  setSearch,
  categoryValue,
  sentBy,
  dateFilter,
  control,
  dropdownChange,
  reset,
  register,
  t,
  setDateFilter,
}) {
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);
  const { category, users } = useSelector(notesSliceSelector);
  const options = category.map(
    ({ standardNoteText, standardNoteTextFr, standardNoteID }, index) => {
      return {
        value: standardNoteID,
        label: standardNoteText,
      };
    }
  );
  return (
    <div className="flex flex-flow pr-[39px] pt-[32px] relative">
      <div className="mr-4 relative">
        <svg
          className="absolute left-[12px] top-[8px]"
          width="24"
          height="24"
          fill="none"
        >
          <path
            d="M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM21 21l-4.35-4.35"
            stroke="#231F20"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <input
          className="!border !border-black !rounded-sm h-10 pl-[44px] w-[347px]"
          type="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={t("searchNotes")}
        />
      </div>
      <button
        id="filter"
        type="button"
        onClick={() => setIsComponentVisible(true)}
        className="!rounded-sm btn__secondary flex h-10 w-[100px]"
      >
        <svg className="mr-2" width="20" height="20" fill="none">
          <path
            d="M5 16v-5M5 9V4M10 16v-6M10 7V4M15 16v-3M15 10V4M3 11h4M8 7h4M13 13h4"
            stroke="#000"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>{" "}
        {t("filter")}
      </button>

      <div ref={ref}>
        <div
          className="absolute bg-white border border-primary-yellow custom__filter w-[300px] flex-flow gap-4  px-[32px] py-6 right-[39px] rounded-sm top-[80px] z-[11]"
          style={{ display: isComponentVisible ? "" : "none" }}
        >
          {" "}
          <label>{t("sentBy")}</label>
          <div className="custom__dropdown-wrapper w-[236px]">
            <SelectFormField
              options={users.map((user) => {
                return { value: user, label: user };
              })}
              dropdownChange={dropdownChange}
              control={control}
              loading={false}
              fieldName={`sentBy`}
              currentValue={sentBy}
              placeholder="Select user"
              mainDivClass="font-semibold inline-flex"
              ariaLabel="sentBy"
              selectClassNames="custom__dropdown-wrapper h-[40px] w-[230px]"
              // defaultOption={
              //   <span className="break-keep current__label-value font-[600] font-open-sans leading-[21.79px] text-[#231F20] text-[16px] text-start w-full">
              //     Select
              //   </span>
              // }
            />
          </div>
          <div className="custom__dropdown-wrapper w-[120px] my-8">
            <label>Date</label>
            <input
              type="date"
              value={dateFilter || ""}
              onChange={(e) => setDateFilter(e.target.value)}
              className={"datepicker relative underwritting w-[234px]"}
            />
          </div>
          <span
            className="link self-center"
            style={{ cursor: "pointer" }}
            onClick={() => {
              reset();
              setDateFilter(null);
            }}
          >
            {t("clear")}
          </span>
        </div>
      </div>
    </div>
  );
}

export default React.memo(NotesFilter);
